export const HISTORY_INTRO_SECTION_ID = "history-intro";

export interface HistoryTimelineItem {
    id: string;
    label: string;
    ariaLabel: string;
    kind?: "intro" | "event" | "showroom";
}
